import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { BaseSummaryControlDirective } from '../base/base-summary-control';
import { VraagboomNumberResultaat } from '@models/vragenboom';

@Component({
  selector: 'app-decimal-summary',
  templateUrl: './decimal-summary.component.html',
  styleUrls: ['./decimal-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DecimalSummaryComponent extends BaseSummaryControlDirective<VraagboomNumberResultaat> implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() { }
}
